import { get } from 'lodash';

import app from '../app';

const allowedCategories = [
  'flatRent',
  'flatSale',
];

app.service('simpleFormService',
  function(
    addFormService,
    btiService,
    homeownerService,
    userService,
  ) {
  'ngInject';

  this.isEnabled = () => {
    const isCatergoryAllowed = allowedCategories.includes(addFormService.ad.category);
    const isByHomeowner = addFormService.ad.isByHomeowner;
    const isAuthenticated = userService.isAuthenticated;
    const userCanPublishThisOfferAsHomeowner = homeownerService.userCanPublishThisOfferAsHomeowner;
    const isHomeownerOfferEditing = isByHomeowner && !userCanPublishThisOfferAsHomeowner && addFormService.ad.id;

    if (isByHomeowner && isCatergoryAllowed) {
      if (!isAuthenticated) {
        return true;
      }

      if (userCanPublishThisOfferAsHomeowner) {
        return true;
      }

      if (isHomeownerOfferEditing) {
        return true;
      }
    }

    return false;
  }

  let aboutBuildingPreviewVisible = true;
  this.isAboutBuildingPreviewVisible = () => this.isEnabled() && aboutBuildingPreviewVisible && (btiService.isBtiProcessed() || get(addFormService.ad, 'id'));
  this.showAboutBuildingFields = () => aboutBuildingPreviewVisible = false;
})
.factory('isSimpleFormEnabled', ['simpleFormService', function(simpleFormService) {
  return simpleFormService.isEnabled;
}]);
